import {FC, memo, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import ComponentButton from '../../../components/ComponentButton'
import {TModuleListDownloader} from '../_types'
import {Form as FormikForm, Formik} from 'formik'
import setModalIndex from '../../../helpers/setModalIndex'
import ComponentCheckbox from '../../../components/ComponentCheckbox'
import { Modal } from 'react-bootstrap'

export const DownloaderModule: FC<TModuleListDownloader> = memo(({ title, handleDownload, columns }) => {
  const intl = useIntl()
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [exportAllLoading, setExportAllLoading] = useState(false)
  const handleDownloadSubmit = async (selectedColumns: Array<string>, exportAll?: boolean) => {
    try {
      exportAll ? setExportAllLoading(true) : setLoading(true)
      await handleDownload(selectedColumns, exportAll)
      setShowModal(false)
    } finally {
      exportAll ? setExportAllLoading(false) : setLoading(false)
    }
  }
  const initialSelectedColumns = useMemo(() => {
    return columns.map(column => column.article)
  }, [columns])

  return <div>
    <ComponentButton
      className="moduleList_downloaderModuleButton"
      type="custom"
      settings={{ title, icon: "download", background: "light" }}
      customHandler={() => setShowModal(true)}
    />
    <Modal show={showModal} onHide={() => setShowModal(false)} onEntering={setModalIndex}>
      <Formik initialValues={{
        select: initialSelectedColumns
      }}
              onSubmit={values => handleDownloadSubmit(values.select)}>
        {({ values, setFieldValue, handleSubmit }) => <FormikForm>
          <Modal.Header>
            <Modal.Title>{intl.formatMessage({ id: "LIST.DOWNLOADER_MODAL_TITLE" })}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {columns.map(column => <ComponentCheckbox
              key={column.article}
              className="moduleList_downloaderModuleCheckbox"
              customChecked={values.select.includes(column.article)}
              customHandler={() => {
                const selectedColumnsClone = [...values.select]
                if (selectedColumnsClone.includes(column.article)) {
                  const currentArticleIndex = selectedColumnsClone.indexOf(column.article)
                  selectedColumnsClone.splice(currentArticleIndex, 1)
                } else {
                  selectedColumnsClone.push(column.article)
                }
                setFieldValue("select", selectedColumnsClone)
              }}
              label={column.title}
            />)}
          </Modal.Body>
          <Modal.Footer>
            <div className="componentButton_container">
              <ComponentButton
                type="submit"
                settings={{ title: intl.formatMessage({ id: "BUTTON.CANCEL" }), background: "light", icon: "" }}
                customHandler={() => setShowModal(false)}
              />
              <ComponentButton
                type="submit"
                settings={{ title: intl.formatMessage({ id: "BUTTON.SUBMIT" }), background: "dark", icon: "" }}
                customHandler={handleSubmit}
                loading={loading}
                disabled={!values.select.length || exportAllLoading}
              />
              <ComponentButton
                type="custom"
                settings={{ title: intl.formatMessage({ id: "LIST.DOWNLOADER_EXPORT_ALL_BUTTON_TITLE" }), background: "dark", icon: "" }}
                customHandler={() => handleDownloadSubmit(values.select, true)}
                loading={exportAllLoading}
                disabled={!values.select.length || loading}
              />
            </div>
          </Modal.Footer>
        </FormikForm>}
      </Formik>
    </Modal>
  </div>
})